<div class="focus-shape-wrapper" [style.width.px]="size" [style.height.px]="size">
    <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <!-- Circle -->
        <circle *ngIf="shape === FocusShapeType.Circle"
            cx="24" cy="24" r="20" fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Square -->
        <rect *ngIf="shape === FocusShapeType.Square"
            x="4" y="4" width="40" height="40" fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Triangle -->
        <polygon *ngIf="shape === FocusShapeType.Triangle"
            points="24,4 4,44 44,44" fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Star (5-pointed) -->
        <polygon *ngIf="shape === FocusShapeType.Star"
            points="24,2 29.5,17.5 46,17.5 32.5,27.5 37,44 24,34 11,44 15.5,27.5 2,17.5 18.5,17.5"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Heart -->
        <path *ngIf="shape === FocusShapeType.Heart"
            d="M24 42 C24 42 4 28 4 16 C4 8 10 4 16 4 C20 4 23 6 24 10 C25 6 28 4 32 4 C38 4 44 8 44 16 C44 28 24 42 24 42Z"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Diamond -->
        <polygon *ngIf="shape === FocusShapeType.Diamond"
            points="24,2 44,24 24,46 4,24"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Cross/Plus -->
        <path *ngIf="shape === FocusShapeType.CrossPlus"
            d="M18,4 L30,4 L30,18 L44,18 L44,30 L30,30 L30,44 L18,44 L18,30 L4,30 L4,18 L18,18 Z"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Hexagon -->
        <polygon *ngIf="shape === FocusShapeType.Hexagon"
            points="24,3 43,14 43,34 24,45 5,34 5,14"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Teardrop -->
        <path *ngIf="shape === FocusShapeType.Teardrop"
            d="M24,4 C24,4 40,20 40,30 C40,39 33,46 24,46 C15,46 8,39 8,30 C8,20 24,4 24,4Z"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>

        <!-- Lightning -->
        <polygon *ngIf="shape === FocusShapeType.Lightning"
            points="28,2 12,22 22,22 16,46 36,22 26,22 32,2"
            fill="var(--color1)" stroke="var(--color22)" stroke-width="2"/>
    </svg>
</div>
